<style>
    p {
        text-align: justify;
    }
</style>
<div class="container" style="padding-top:50px">
    <div _ngcontent-oou-c51="" class="row" style="padding-top: 50px;padding-bottom: 71px;">


        <p style="    text-align: left;
        font-size: 23px;
        padding-top: -11px;
        font-family: fangsong;
        color: #532ABA;
        font-weight: 500;">Disclaimer</p>

<p><b>Interpretation and Definitions</b></p>
<p></p>
<b>Interpretation</b>
<p></p>
<p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
<p></p>
<b>Definitions</b>
<p></p>
<p>For the purposes of this Disclaimer:</p>
<p></p>

<p>Company (referred to as either "the Company", "We", "Us" or "Our" in this Disclaimer) refers to Dusane Infotech India Pvt. Ltd., 4th Floor, TJSB House, Sambhav IT Park Road No 1, Plot # B5, Wagle Estate, MIDC, Thane West, Thane, Maharashtra 400604.</p>
<p></p>
<p>Service refers to the Website.</p>
<p></p>
<p>You means the individual accessing the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p>
<p></p>
<p>Website refers to Cambioscope, accessible from www.cambioscope.com</p>
<p></p>
<b>Disclaimer</b>
<p></p>
<p>The information contained on the Service is for general information purposes only.</p>
<p></p>
 
<p>The Company assumes no responsibility for errors or omissions in the contents of the Service.

In no event shall the Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Company reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice. This Disclaimer has been created with the help of the TermsFeed Disclaimer Generator.</p>
<p></p>

<p>The Company does not warrant that the Service is free of viruses or other harmful components.</p>
<p></p>

<b>External Links Disclaimer</b>
<p></p>
<p>The Service may contain links to external websites that are not provided or maintained by or in any way affiliated with the Company.</p>
<p></p>

<p>Please note that the Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.</p>
<p></p>

<b>Errors and Omissions Disclaimer</b>
<p></p>
<p>The information given by the Service is for general guidance on matters of interest only. Even if the Company takes every precaution to insure that the content of the Service is both current and accurate, errors can occur. Plus, given the changing nature of laws, rules and regulations, there may be delays, omissions or inaccuracies in the information contained on the Service.</p>
<p></p>

<p>The Company is not responsible for any errors or omissions, or for the results obtained from the use of this information.</p>
<p></p>

<b>Fair Use Disclaimer</b>
<p></p>
<p>The Company may use copyrighted material which has not always been specifically authorized by the copyright owner. The Company is making such material available for criticism, comment, news reporting, teaching, scholarship, or research.</p>
<p></p>

<p>The Company believes this constitutes a "fair use" of any such copyrighted material as provided for in section 107 of the United States Copyright law.</p>
<p></p>

<p>If You wish to use copyrighted material from the Service for your own purposes that go beyond fair use, You must obtain permission from the copyright owner.</p>
<p></p>

<b>Views Expressed Disclaimer</b>
<p></p>
<p>The Service may contain views and opinions which are those of the authors and do not necessarily reflect the official policy or position of any other author, agency, organization, employer or company, including the Company.</p>
<p></p>

<p>Comments published by users are their sole responsibility and the users will take full responsibility, liability and blame for any libel or litigation that results from something written in or as a direct result of something written in a comment. The Company is not liable for any comment published by users and reserves the right to delete any comment for any reason whatsoever.</p>
<p></p>

<b>No Responsibility Disclaimer</b>
<p></p>
<p>The information on the Service is provided with the understanding that the Company is not herein engaged in rendering legal, accounting, tax, or other professional advice and services. As such, it should not be used as a substitute for consultation with professional accounting, tax, legal or other competent advisers.</p>
<p></p>

<p>In no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access or use or inability to access or use the Service.</p>
<p></p>

<b>"Use at Your Own Risk" Disclaimer</b>
<p></p>
<p>All information in the Service is provided "as is", with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind, express or implied, including, but not limited to warranties of performance, merchantability and fitness for a particular purpose.</p>
<p></p>

<p>The Company will not be liable to You or anyone else for any decision made or action taken in reliance on the information given by the Service or for any consequential, special or similar damages, even if advised of the possibility of such damages.</p>
<p></p>

<b>Contact Us</b>
<p></p>
<p>If you have any questions about this Disclaimer, You can contact Us:</p>
<p></p>
<p>By email: cambioscope@dusaneinfotech.com</p>

    </div>
</div>